import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ScDialogData } from '../../models';
import { ScConfirmationDialogComponent } from './sc-confirmation-dialog/sc-confirmation-dialog.component';
import { ScErrorDialogComponent } from './sc-error-dialog/sc-error-dialog.component';
import { ScFileViewerDialogComponent } from './sc-file-viewer-dialog/sc-file-viewer-dialog.component';
import { ScFullscreenDialogComponent } from './sc-fullscreen-dialog/sc-fullscreen-dialog.component';
import { ScGenericDialogComponent } from './sc-generic-dialog/sc-generic-dialog.component';
import { ScGoogleMapsDialogComponent } from './sc-google-maps-dialog/sc-google-maps-dialog.component';
import { ScImagePreviewDialogComponent } from './sc-image-preview-dialog/sc-image-preview-dialog.component';
import { ScInfoDialogComponent } from './sc-info-dialog/sc-info-dialog.component';
import { ScSuccessDialogComponent } from './sc-success-dialog/sc-success-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class ScDialogService {
  constructor(private _matDialog: MatDialog) {}

  public fileViewer(title: string, type: string, src: File | string): Observable<boolean> {
    const dialogRef = this._matDialog.open(ScFileViewerDialogComponent, {
      data: {
        title,
        type,
        src
      },
      minWidth: '500px',
      minHeight: '500px',
      disableClose: true
    });

    return dialogRef.afterClosed();
  }

  public confirm(message: string): Observable<boolean> {
    const dialogRef = this._matDialog.open(ScConfirmationDialogComponent, {
      width: '400px',
      data: message,
      disableClose: true
    });

    return dialogRef.afterClosed();
  }

  public info(title: string, text: string, type?: number): Observable<boolean> {
    const dialogRef = this._matDialog.open(ScInfoDialogComponent, {
      width: '600px',
      data: { title, text, type },
      disableClose: true
    });

    return dialogRef.afterClosed();
  }

  public fullscreen(title: string, content: any): Observable<boolean> {
    const dialogRef = this._matDialog.open(ScFullscreenDialogComponent, {
      minWidth: '100vw',
      height: '100vh',
      data: { title, content },
      disableClose: true
    });

    return dialogRef.afterClosed();
  }

  public succsess(successMessage: { title: string; message: string }): Observable<any> {
    const dialogRef = this._matDialog.open(ScSuccessDialogComponent, {
      width: '400px',
      data: { successMessage },
      disableClose: true,
      autoFocus: false
    });

    return dialogRef.afterClosed();
  }

  public error(
    errorMessage: {
      title: string;
      errorList: string[];
    },
    type: 'error' | 'warning' = 'error'
  ): Observable<any> {
    const dialogRef = this._matDialog.open(ScErrorDialogComponent, {
      width: '400px',
      data: { errorMessage, type },
      disableClose: true,
      autoFocus: false
    });

    return dialogRef.afterClosed();
  }

  public imagePreviewer(images: any[], startIndex = 0): Observable<any> {
    const dialogRef = this._matDialog.open(ScImagePreviewDialogComponent, {
      data: {
        urls: images.map(url => ({
          ...url,
          type: 'image'
        })),
        startIndex
      },
      disableClose: true,
      autoFocus: false
    });

    return dialogRef.afterClosed();
  }

  public googleMaps(title: string, long: number, lat: number) {
    const dialogRef = this._matDialog.open(ScGoogleMapsDialogComponent, {
      width: '600px',
      height: '600px',
      data: { long, lat, title },
      disableClose: true,
      autoFocus: false
    });

    return dialogRef.afterClosed();
  }

  public generic(config: ScDialogData): Observable<any> {
    config.actions = config.actions
      ? config.actions
      : [
          {
            text: 'Cancel',
            type: 'default'
          },
          {
            text: 'Submit',
            type: 'primary'
          }
        ];

    const { width, maxWidth, ...restConfig } = config;
    const dialogRef = this._matDialog.open<any, ScDialogData>(ScGenericDialogComponent, {
      disableClose: true,
      width: width || '700px',
      maxWidth: maxWidth || 'auto',
      data: restConfig,
      autoFocus: false
    });
    return dialogRef.afterClosed();
  }
}
